<template>
  <!--stateStorage="session"
    stateKey="dt-state-demo-session"-->
  <DataTable
    :value="listDataService"
    :lazy="true"
    class="p-datatable-responsive"
    selectionMode="single"
    data-key="id"
    @page="onPage($event)"
    :paginator="pagination"
    :totalRecords="totalRecords"
    :rows="paginationRows"
    :loading="loading"
    :first="firstRecordIndex"
    :scrollable="(scrollHeight !== '' ? true : false) "
    :scrollHeight="scrollHeight"
    :autoLayout="true"
    filterMatchMode="startsWith"
    :rowsPerPageOptions="$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS"
    :currentPageReportTemplate=" $constants.LIST_OPTION_COMMON.TEXT_TOTAL_ITEM+' {totalRecords}'"
    :paginatorTemplate="$constants.LIST_OPTION_COMMON.PAGINATOR_TEMPLATE"
  >
    <Column
      v-for="c in model.getDisplayFields()"
      :key="c.key"
      :field="getField(c)"
      :header="getLabel(c)"
      :ref="getField(c)"
      :filterMatchMode="getFilterMatch(c)"
      :sortable="getSortable(c)"
      :bodyClass="(c.class ? 'txt-' + c.class : '')"
      :bodyStyle="getHeaderStyle(c)"
      :headerStyle="getHeaderStyle(c)"
      :headerClass="(c.class ? 'txt-' + c.class : '')"
    >
      <template #body="slotProps">
        <!--{{c}}-->
        <img
          v-if="getType(c) == 'Image'"
          :src="getData(c, slotProps.data)"
          style="width: 80px; height: 80px"
        />
        <div
          v-else-if="c.type == 'Text'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'CustomUrl'"
          v-html="callbackCustomUrl(c, slotProps.data)"
          @click="redirectList(slotProps.data, $event)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'CustomPopup'"
          v-html="callbackCustomUrl(c, slotProps.data)"
          @click="DetailData(slotProps.data,c)"
          :style="(c.style ? c.style : '')"
        ></div>
        <Checkbox
          v-else-if="getType(c) == 'Checkbox'"
          v-model="slotProps.data[slotProps.column.field]"
          :binary="true"
          @change="onInputChange($event, slotProps.data, c)"
        />
        <div v-else-if="getType(c) == 'MultiSelect'"  v-html="callbackDataMultiSelect( c ,slotProps.data)"></div>
        <div v-else>
          <div v-if="c.custom">
            <Avatar v-if="c.custom == 'image'" :image="getData(c, slotProps.data)" size="xlarge"  />
            <div v-if="c.custom == 'SelectionText'"  v-html="callbackDataSelect( c ,slotProps.data)"></div>
          </div>
          <span v-else v-html="getData(c, slotProps.data)" :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
        </div>


      </template>
      <template v-if="c.filter" #filter>
        <InputText
          v-if="c.filter.type == 'input'"
          type="text"
          v-model="filters[getField(c)]"
          class="p-column-filter"
          :placeholder="getFilterPlaceHolder(c)"
          @keyup="onFilter($event,c.filter.type,c.key)"
        />
        <Dropdown
          :key="countDropdown"
          v-if="c.filter.type == 'select'"
          v-model="filters[getField(c)]"
          :options="getFilterOptions(c.key)"
          :optionLabel="c.filter.optionLabel"
          :optionValue="c.filter.optionKey"
          :placeholder="getFilterPlaceHolder(c)"
          class="p-column-filter"
          :showClear="true"
          appendTo="body"

          @change="onFilter($event,c.filter.type,c.key)"
        >
          <template #option="slotProps">
            <div class="p-clearfix">
              <span
                :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
                >{{ slotProps.option[c.filter.optionLabel] }}</span
              >
            </div>
          </template>
        </Dropdown>
        <DropdownScrollable
          v-if="c.filter.type == 'SelectScroll'"
          :limit="options[c.key]?.limit"
          :loading="options[c.key]?.loading"
          v-model="filters[getField(c)]"
          :options="options[c.key]?.items"
          :total="options[c.key]?.total"
          @click="(value) => onEventOptions('click', c.key, value, c.filter.type)"
          @keyup="(value) => onEventOptions('keyup', c.key, value, c.filter.type)"
          @scroll="(value) => onEventOptions('scroll', c.key, value, c.filter.type)"
          @offset="(value) => onEventOptions('offset', c.key, value, c.filter.type)">
          <template #label="slotProps">
            <div class="p-clearfix">
              <span>{{ slotProps[c.filter.optionLabel] }}</span>
            </div>
          </template>
        </DropdownScrollable>
        <Calendar
          v-if="c.filter.type == 'DateRange'"
          :showOnFocus="false"
          :monthNavigator="true"
          :yearNavigator="true"
          :yearRange="yearRange"
          dateFormat="yy-mm-dd" 
          :placeholder="getFilterPlaceHolder(c)"
          v-model="filters[getField(c)]"
          class="p-column-filter"
          :showIcon="true"
          selectionMode="range"
          appendTo="body"
          :showClear="true"
          :showButtonBar="true"
          @clear-click="onFilter($event,c.filter.type,c.key)"
          @date-select="onFilter($event,c.filter.type,c.key)"
          :manualInput="false"
          />
      </template>
    </Column>
    <Column
      v-if="actions"
      headerStyle="width: 8em; text-align: center"
      bodyStyle="width: 8em; text-align: center"
    >
      <template #body="slotProps">
        <span class="p-column-title">Actions</span>
        {{ slotProps.data.color }}
        <span v-for="(a, k) in actions.rows(slotProps.data)" :key="k">
          <Button
            v-if="a.name == 'edit' || a.name == 'delete' || a.name == 'view'"
            type="button"
            :icon="getIcon(a.icon)"
            :class="getClass(a.name)"
            style="margin: 2px"
            v-tooltip="a?.title"
            v-on:click="actionsClicked(k, a, slotProps)"
          ></Button>
          <Button v-else-if="a.name=='history'"
            v-on:click="actionsClicked(k, a, slotProps)"
            class="button-box p-button-history p-button-icon-only"
            style="margin: 2px;height: 30px;"
            v-tooltip="a?.title"
          ><span class="material-icons" style="font-size: 22px;">history</span></Button>
          <Button v-else-if="a.name == 'evaluation'"
            v-on:click="actionsClicked(k, a, slotProps)"
            class="button-box p-button-evaluate p-button-icon-only"
            style="margin: 2px;height: 30px;"
            v-tooltip="a?.title"
          ><svg
              class="material-design-icon__svg"
              width="22"
              height="22"
              viewBox="0 0 24 25">
              <path d="M18,9 L16.59,7.58 L10,14.17 L7.41,11.59 L6,13 L10,17 L18,9 Z M19,3 L14.82,3 C14.4,1.84 13.3,1 12,1 C10.7,1 9.6,1.84 9.18,3 L5,3 C4.86,3 4.73,3.01 4.6,3.04 C4.21,3.12 3.86,3.32 3.59,3.59 C3.41,3.77 3.26,3.99 3.16,4.23 C3.06,4.46 3,4.72 3,5 L3,19 C3,19.27 3.06,19.54 3.16,19.78 C3.26,20.02 3.41,20.23 3.59,20.42 C3.86,20.69 4.21,20.89 4.6,20.97 C4.73,20.99 4.86,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 Z M12,2.75 C12.41,2.75 12.75,3.09 12.75,3.5 C12.75,3.91 12.41,4.25 12,4.25 C11.59,4.25 11.25,3.91 11.25,3.5 C11.25,3.09 11.59,2.75 12,2.75 Z M19,19 L5,19 L5,5 L19,5 L19,19 Z" fill="#fcfcfc"></path>
            </svg>
          </Button>
        </span>
      </template>
      <template #header="slotProps">
        <Button
          v-if="actions.header"
          type="button"
          v-tooltip="actions.header?.title"
          :icon="getIcon(actions.header.icon)"
          :class="getClass(actions.header.name)"
          v-on:click="actionsClicked(actions.header.name, actions.header, slotProps)"
        ></Button>
      </template>
    </Column>
    <template #empty>
      <div class="text-center">{{ $t('datatable.empty') }}</div>
    </template>
    <template #loading>
      <div class="text-center">{{ $t('datatable.loading') }}</div>
    </template>
    <Dialog header="Rất cảnh báo" :visible.sync="popupWarning" >
      <h1 class="txt-center txt-required">HỆ THỐNG ĐANG PHÁT TRIỂN  !!!!!!!!!!!!!</h1>
    </Dialog>
  </DataTable>
</template>

<script>
import moment from "moment-timezone";
import ApiRepository from "@/core/ApiRepository";
import DropdownScrollable from '@/components/DropdownScrollable';
export default {
  components:{
    DropdownScrollable
  },
  props: {
    model: Object,
    tableData: Array,
    getFilterOptions: Function,
    actions: Object,
    options: Array,
    whereKeyList: Object,
    department_obj:Object,
    company:Object,
    company_id: String,
    evaluation_form:Object,
    ind_category:Object,
    type_situation_index:Object,
  },
  data() {
    return {
      filters: {},
      countDropdown: 0,
      pagination: true, // true cho phép phân trang
      paginationRows: this.$constants.LIST_OPTION_COMMON.PAGINATION_ROWS_DEFAULT, // số dòng trên 1 trang
      scrollHeight: '', // chiều cao của trang danh sách
      loading: true,
      rowsPerPageOptions: [10, 20, 50, 100],
      first: 0,
      totalRecords: 120,
      totalRecords2: 12,
      test: null,
      listDataService:null,
      filtersCustom: {},
      lazyParams: {},
      page_transaction:null,
      firstRecordIndex:0,
      yearRange : "2022:2300",
      time_zone_local : moment.tz.guess(true),
      popupWarning: false
    };
  },
  async created() {
    var year = new Date().getFullYear()
    var yearRange = '2022:'+(year+100);
    this.yearRange = yearRange+''
    this.test = this.tableData;
  },
  watch: {
    // async "$props.company"() {
    //   console.log("companycompany", this.company);
    //   await this.onLazyEvent()
    // },
    // async "$props.company_id"() {
    //   console.log("companycompany", this.company_id);
    //   await this.onLazyEvent();
    // }
  },
  mounted () {
    this.lazyParams = {
      first: 0,
      rows: this.paginationRows,
      sortField: null,
      sortOrder: null,
      filters: this.filters
    };
    /*
    * stateStorage="session"
    stateKey="dt-state-demo-session"
    * phai them thuoc tinh nay vao table
    * */
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
        this.lazyParams = (localStorage.getItem(this.page_transaction)) ? JSON.parse(localStorage.getItem(this.page_transaction)) : {};
        this.firstRecordIndex = this.lazyParams.first;
        // console.log("this.lazyParams:22222222",this.lazyParams);
        /*if (this.lazyParams){
          this.filters = (this.lazyParams.filters) ? this.lazyParams.filters : {};
        }*/
      }
    }
    this.loading = false
    this.countDropdown++;
    this.onLazyEvent();
  },
  methods: {
    async onEventOptions(e, key, data, type) {
      this.$delete(this.options[key].filters, 'name');
      if (data) {
        this.options[key].filters.name = data;
      }
      this.$emit("onEventOptions", {event: e, key:key, data: this.options[key]});
      if (e == 'click') {
        await this.onFilter(e,type,key);
      }
    },
    select_date(event,col_name) {
      if (this.filters[col_name][0] !== null && this.filters[col_name][1] !== null) {
        this.$emit("filter_date", {
          data: this.filters[col_name],
          col: col_name
        });
      }
    },
    getLabel(col) {
      if (col.label) return col.label;
      else return col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") {
        return "Custom";
      }
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") {
            return "Image";
          }
          if (col.inputOptions?.mode == "selection") {
            return "Select";
          }
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          }
          if(col.inputOptions?.mode == 'icon') {
            return "Icon";
          }
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          } else if (col.inputOptions?.mode == "percentage") {
            return "Percentage";
          } else {
            return "Number";
          }
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    cannotEdit(col) {
      if (col.edit && col.edit.edit == false) return true;
      return false;
    },
    onInputChange(value, data, f) {
      if (f.onChange)  f.onChange(data).bind(this);
      this.$emit("onDataChange", data, f);
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "";
      // if  (col.key == 'name'){
      //   style = "width:"+ 20 +"%;"
      // }else 
      if (col.width) style = "width: " + col.width + "%;";
      return style;
    },
    getData(col, row) {
      // console.log("this.options:",this.options)
      var value = '';
      if (col.type == "Date" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("DD/MM/yyyy");
      } else if (col.type == "Datetime" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("DD/MM/yyyy HH:mm");
      } else if (col.type == "CustomDate" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm - DD/MM/yyyy");
      } else if(col.type == "Hour" && row[col.key]){
        value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm");
      } else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (col.models !== undefined && this.options[col.key] !== undefined) {
          // console.log("col.models:",col.models);
          lists = this.options[col.key];
        }
        if (lists && lists.length) {
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult).length) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else {
        if (col.type == "Text" && row[col.key] && row[col.key].length > 100) {
          var result = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        if (this.getType(col) == "Percentage") {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + "%";
        }
        value = row[col.key];
      }
      if (col.style) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter( a => a.value  === row[col.key]);
        if (Object.keys(filtered) && Object.entries(filtered).length && filtered[0].style) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      }
      return value
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      return filterMatch;
    },
    getFilterPlaceHolder(col) {
      if (col.filter.placeHolder) {
        return col.filter.placeHolder;
      } else if (col.filter.type == "select") {
        return `Chọn`;
      } else if (col.filter.type == "input") {
        return `Nhập`;
      } else {
        return ``;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    actionsClicked(key, action, rowData) {
      console.log(action);
      this.$emit("action-click", {
        originalEvent: event,
        action: action,
        key: key,
        data: rowData,
        lazyParams:this.lazyParams
      });
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
        case "adddebt":
          return "p-button-edit"
        case "add-Debt":
          return "p-button-add";
        case "editcustom":
          return "p-button-edit"
        case "addcustom":
          return "p-button-add";
        case "calculator":
          return "main-style-button";
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("vi-VN", {
        style: "currency",
        currency: "VND"
      });
    },
    redirectList(data, e) {
      let clickedElId = e.target.id
      console.log(data.id)
      if (clickedElId === 'evaluation-form') {
      //   var id = data.id;
      //   var path = `/admin/evaluation-form/${id}`;
      //   this.$router.push({path: path})
        this.popupWarning = true;
      }
    },
    callbackCustomUrl(c,data){
      var text = ''
      // console.log("data==========",data);
      switch(c.key) {
        case 'users':
          text = '<a class="txt-link" id="list-users" :data-id="'+data.id+'">'+data.users+'</a>';
          break;
        case 'danger_total':
          text = '<a class="txt-link" id="list-danger_total" :data-id="'+data.id+'">'+data.danger_total+'</a>';
          break;
        case 'point_rb':
          text = `<a class="txt-link-popup txt-rb">`+this.formatNumber(data.point_rb,0)+'</a>'
          break;
        case 'point_re':
          if(data.point_re && data.point_re >= 0){
            text = `<a class="txt-link-popup txt-re">`+this.formatNumber(data.point_re,0)+'</a>'
          }
          break;
        case 'point_ra':
          if(data.point_ra && data.point_ra >= 0){
            text = `<a class="txt-link-popup txt-ra">`+this.formatNumber(data.point_ra,0)+'</a>'
          }
          break;
        case 'bpks_text':
          if(data.bpks){
            if(this.$store.getters.controllers?.control_measures && this.$store.getters.controllers?.control_measures.includes('list')){
              text = `<a class="txt-link-bpks">`+this.formatNumber(data.bpks.total_approve,0)+'/'+this.formatNumber(data.bpks.total,0)+'</a>'
            }else{
              text = `<a>`+this.formatNumber(data.bpks.total_approve,0)+'/'+this.formatNumber(data.bpks.total,0)+'</a>'
            }
          }
          break;
        case 'code_rb' :
          if(data.code_rb){
            text = `<span class="txt-rb">`+data.code_rb+`</span>`
          }
          break;
        case 'code_re' :
          if(data.code_re){
            text = `<span class="txt-re">`+data.code_re+`</span>`
          }
          break;
        case 'code_ra' :
          if(data.code_ra){
            text = `<span class="txt-ra">`+data.code_ra+`</span>`
          }
          break;
        default:
          break;
      }
      // this.date_now
      return text;
    },
    callbackDataMultiSelect(c, data) {
      var text = "";
      switch(c.key) {
        case 'department':
          if(data.department){
            text += `<div class="">${data.department.name}</div>`;
          }
          break;
        case 'areas':
          if(data.areas){
            text += `<div class="">${data.areas.name}</div>`;
          }
          break;
        default:
      }
      return text;
    },
    callbackDataSelect(c,data){
      var text = "";
      switch(c.key) {
        case 'active':
          text = data.active ? `<i class="pi pi-check success bold"></i>` : `<i class="pi pi-times danger bold"></i>`;
          break;
        case 'status':
          // console.log("data==",data)
          if(data.status){
            if(data.status == 'NEW'){
              text = 'Mới'
            }else if(data.status == 'REVIEW'){
              text = 'Chờ review'
            }else if(data.status == 'WAITTING_APPROVED'){
              text = 'Chờ approve'
            }else if(data.status == 'APPROVED'){
              text = 'Đã approve'
            }else if(data.status == 'COMPLETE'){
              text = 'Đã đóng'
            }
          }

          break;
        case 'department':
          text = data.active ? `<i class="pi pi-check success bold"></i>` : `<i class="pi pi-times danger bold"></i>`;
          break;
        default:
      }
      return text;
    },
    async dataList(lazyParams) {
      var filters = lazyParams.filters;
      var company_id = this.company?.id ?? null;
      var type_login = this.$store.getters.type ? this.$store.getters.type : null;
      if(type_login != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.company_id ?? null;
      }
      filters.company_id = company_id;
      var listData = [];
      var total = 0;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if (this.$commonFuction.isEmptyObject(this.evaluation_form)) {
        return  {
          listData: listData,
          total: total,
        }
      }
      if(!this.$commonFuction.isEmptyObject(this.ind_category)){
        filters.category_id = this.ind_category.id
      }
      if(!this.$commonFuction.isEmptyObject(this.type_situation_index)){
        filters.type = this.type_situation_index.id
      }
      filters.evaluation_form_id = this.evaluation_form.id 
      console.log("company_id===",company_id)
      if(token && company_id){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/evaluation_form_danger/list", {filters, limit: lazyParams.rows, offset: lazyParams.first, company_id:company_id}, {headers}).then(function (response) {
            // console.log(response.data);
            var data = response.data.data;
            listData = data.list;
            if(listData && listData.length > 0){
              for (let i = 0; i < listData.length; i++) {
                const e = listData[i];
                var situation_name = e.situation_name
                var danger_name = e.danger_name
                if(e.situation_type == 'other'){
                  situation_name = e.other_situation_name
                }
                if(e.danger_type == 'other'){
                  danger_name = e.other_danger_name
                }
                listData[i].situation_name = situation_name
                listData[i].danger_name = danger_name
              }
            }
            total = data.total;
        }).catch((err)=> {
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
          });
        })
      }
      var dataRes = {
        listData: listData,
        total: total,
      };
      return dataRes;
    },
    async onLazyEvent() {
      this.lazyParams.filters = this.filtersCustom;
      console.log('this.filtersCustom:',this.filtersCustom)
      this.loading = true;
      var that =this;
      await this.dataList(this.lazyParams).then(async data => {
        if (data.listData.length < 1) {
          that.listDataService = data.listData;
          that.totalRecords = data.total;
          that.loading = false;
        }
        var stt = this.lazyParams.first;
        for (var i = 0; i < data.listData.length; i++) {
          stt++;
          data.listData[i].stt = stt;
          data.listData[i].work_name = data.listData[i]?.work?.name;
        }
        that.listDataService = data.listData;
        that.totalRecords = data.total;
        that.loading = false;
      });
    },
    onPage(event) {
      this.lazyParams = event;
      this.onLazyEvent();
    },
    async onFilter(event,type_input,key){
      //this.loading = true;
      this.tableData = this.test;
      if(type_input == "DateRange"){
        if(this.filters[key] !== null && this.filters[key][1]== null){
          return false;
        }
      }
      // this.filtersCustom[key] = {
      //   type_input:type_input,
      //   value:this.filters[key],
      // };
      // console.log('this.filters:',this.filters);
      var filter = await this.$CoreService.convertFilter(type_input,key,this.filters);
      this.filtersCustom[key] = filter?.value;
      if(type_input == "SelectScroll"){
        if (event != 'click') {
          return;
        }
        if (key == 'department') {
          this.filtersCustom['department_id'] = this.filtersCustom[key]?.id;
        }else if (key == 'areas') {
          this.filtersCustom['areas_id'] = this.filtersCustom[key]?.id;
        }
      }
      // this.filtersCustom.append(this.filtersCustom[key]);
      // console.log(this.filtersCustom);
      this.lazyParams.first = 0;
      await this.onLazyEvent()
      /*setTimeout(() => {
        this.customers = this.datasource.slice(event.first, event.first + event.rows);
        this.loading = false;
      }, 500);*/
    },
    formatNumber(value,decimals=2){
      const digitsRE = /(\d{3})(?=\d)/g
      value = parseFloat(value)
      if (!isFinite(value) || (!value && value !== 0)) return ''
      decimals = decimals != null ? decimals : 2
      var stringified = Math.abs(value).toFixed(decimals)
      var _int = decimals
        ? stringified.slice(0, -1 - decimals)
        : stringified
      var i = _int.length % 3
      var head = i > 0
        ? (_int.slice(0, i) + (_int.length > 3 ? '.' : ''))
        : ''
      var _float = decimals
        ? stringified.slice(-1 - decimals)
        : ''
      var sign = value < 0 ? '-' : '';
      var text = sign + head +
        _int.slice(i).replace(digitsRE, '$1.') +
        _float
      return text
    }, 
    DetailData(data,col){
      switch (col.key){
        case 'point_rb':
          this.$emit('showPopup',data,'rb')
        break;
        case 'point_re':
          this.$emit('showPopup',data,'re')
        break;
        case 'point_ra':
          this.$emit('showPopup',data,'ra')
        break;
        case 'bpks_text' : 
          if(this.$store.getters.controllers?.control_measures && this.$store.getters.controllers?.control_measures.includes('list')){
            this.$router.push({ path: '/admin/control_measures', query: { company_id: this.company_id,efd_id:data.id } });
          }
      }
      
    },
  }
};
</script>
<style lang="scss">
.p-paginator-bottom{padding: 0 !important;}
/* .p-column-filter{
  width: 100%;
} */
.p-button-label-o{
  color : white;
}
</style>